import React from "react";

import { SvgComponentProps } from "../GenericIconType";
import { SvgWrapper } from "../styles";

const PlusSmall = (props: SvgComponentProps) => {
  const { width = 14, height = 14, color = "#FFFFFF", widthBoxView, heightBoxView } = props;

  return (
    <SvgWrapper>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${widthBoxView || width} ${heightBoxView || height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 1V13M1 7H13"
          stroke={color}
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgWrapper>
  );
};

export default PlusSmall;
